import { observer } from 'mobx-react';
import React from 'react';

import store from 'stores/RootStore';

import FiltersToolbarButton from './FiltersToolbarButton';

function NewFilterSetButton() {
  const filterManager = store.creative?.ads.filter;

  const handleOnClick = () => {
    filterManager?.openNewFilterModal();
  };

  return (
    <FiltersToolbarButton
      disabled={!filterManager}
      label="New"
      onClick={handleOnClick}
    />
  );
}

export default observer(NewFilterSetButton);
